import { WhatYouWantOptionIdType } from '../types';
import { WHAT_YOU_WANT_OPTIONS } from '../WHAT_YOU_WANT_OPTIONS';

export const getWhatYouWantTitleById = (
  id: WhatYouWantOptionIdType | null | undefined,
): string | null => {
  if (!id) return null;
  return (
    WHAT_YOU_WANT_OPTIONS.find((option) => option.id === id)?.title || null
  );
};

const DEFAULT: WhatYouWantOptionIdType = 'deep_connection';
export const getWhatYouWantIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): WhatYouWantOptionIdType | null => {
  const id = WHAT_YOU_WANT_OPTIONS.find((option) => option.title === title)?.id;
  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
